// src/apiUtils/callbackHandler.js
import { getValueByPath, resolveTemplateString } from './objectUtils';
import { initiateJobTracking } from './uplynkCentralInitiator'; // FIXED IMPORT


const callbackRegistry = {
  // API trackers
  uplynkCentralInitiator: (data, config) => {
    // console.log("***************** uplynkCentralInitiator - data, config");
    // console.log(data, config);
    // console.log("Calling uplynkCentralInitiator with config type:", config.configType);
    // console.log("*****************");
    return initiateJobTracking(data, config);
  },
  
  // State updates
  // appendState: (data, config) => {
  //   const { state, extractMapping, messageTemplate } = config;
  //   console.log("** callbackRegistry - appendState");
  //   console.log("** callbackRegistry - data: ", data);
  //   console.log("** callbackRegistry - config: ", config);
  //   console.log("*********");
    
  //   // Extract values from response using mapping
  //   const extractedValues = {};
  //   let missingRequiredFields = [];
    
  //   if (extractMapping) {
  //     Object.entries(extractMapping).forEach(([key, pathOrValue]) => {
  //       // Handle non-string values (like numbers) directly
  //       if (typeof pathOrValue !== 'string') {
  //         extractedValues[key] = pathOrValue;
  //         console.log(`Direct value for '${key}':`, pathOrValue);
  //         return;
  //       }
        
  //       // For string paths, try all possible locations
  //       let value = tryExtractFromMultipleLocations(data, pathOrValue);
        
  //       if (value !== undefined) {
  //         extractedValues[key] = value;
  //       } else {
  //         console.warn(`Could not find value for '${key}' using path '${pathOrValue}' in any location`);
  //         missingRequiredFields.push({ key, path: pathOrValue });
  //       }
  //     });
  //   }
    
  //   console.log("Extracted values:", extractedValues);
    
  //   // Check if any required fields are missing
  //   if (missingRequiredFields.length > 0) {
  //     console.error("Missing required fields:", missingRequiredFields);
      
  //     // Notify user about missing fields if notification function exists
  //     if (config.notificationFunction) {
  //       const missingFields = missingRequiredFields.map(f => f.key).join(', ');
  //       config.notificationFunction(
  //         `Failed to extract required fields: ${missingFields}. Please check your configuration.`, 
  //         'error'
  //       );
  //     }
      
  //     // Return early with error state if abortOnMissingFields is set
  //     if (config.abortOnMissingFields) {
  //       return {
  //         state: 'error',
  //         progress: `Missing required fields: ${missingRequiredFields.map(f => f.key).join(', ')}`,
  //         timestamp: new Date(),
  //         error: true
  //       };
  //     }
  //   }
    
  //   // Process messageTemplate based on type (object or string)
  //   let formattedMessage;
    
  //   if (messageTemplate) {
  //     console.log("if (messageTemplate)", messageTemplate);
  //     if (typeof messageTemplate === 'object') {
  //       console.log("if (typeof messageTemplate === 'object')", messageTemplate);
  //       // Handle object format with title and value
  //       formattedMessage = {
  //         title: messageTemplate.title,
  //         value: messageTemplate.value
  //       };
  //       console.log("messageTemplate - formattedMessage: ", formattedMessage);
        
  //       // Replace template variables in both title and value
  //       Object.entries(extractMapping || {}).forEach(([key, _]) => {
  //         const value = extractedValues[key];
  //         const replaceValue = value !== undefined ? value : 'thisWentWrong';
          
  //         if (formattedMessage.title) {
  //           formattedMessage.title = formattedMessage.title.replace(
  //             new RegExp(`{${key}}`, 'g'), 
  //             replaceValue
  //           );
  //         }
          
  //         if (formattedMessage.value) {
  //           formattedMessage.value = formattedMessage.value.replace(
  //             new RegExp(`{${key}}`, 'g'), 
  //             replaceValue
  //           );
  //         }
  //       });
  //     } else {
  //       console.log("else (typeof messageTemplate === 'object'): ", messageTemplate);
  //       // Handle legacy string format
  //       let message = messageTemplate;
  //       Object.entries(extractMapping || {}).forEach(([key, _]) => {
  //         const value = extractedValues[key];
  //         message = message.replace(
  //           new RegExp(`{${key}}`, 'g'), 
  //           value !== undefined ? value : 'undefined'
  //         );
  //       });
  //       formattedMessage = message;
  //     }
  //     console.log("Formatted message:", formattedMessage);
  //   }
    
  //   // Create job state entry
  //   const jobState = {
  //     state: state || 'info',
  //     timestamp: new Date(),
  //     ...extractedValues
  //   };
    
  //   // Add message properties based on format
  //   if (formattedMessage) {
  //     if (typeof formattedMessage === 'object') {
  //       jobState.title = formattedMessage.title;
  //       jobState.value = formattedMessage.value;
  //       jobState.progress = formattedMessage.value; // For backward compatibility
  //     } else {
  //       jobState.progress = formattedMessage;
  //     }
  //   } else {
  //     jobState.progress = 'Updated'; // Default if no message provided
  //   }
    
  //   console.log("Final job state:", jobState);
    
  //   // Call the provided callback function
  //   if (config.appendFunction) {
  //     try {
  //       config.appendFunction(jobState);
  //     } catch (error) {
  //       console.error("Error in appendFunction:", error);
  //     }
  //   }
    
  //   return jobState;
  // },
  appendState: (data, config) => {
    const { state, extractMapping, messageTemplate } = config;
    // console.log("** callbackRegistry - appendState");
    // console.log("** callbackRegistry - data: ", data);
    // console.log("** callbackRegistry - config: ", config);
    // console.log("*********");
    
    // Extract values from response using mapping
    const extractedValues = {};
    let missingRequiredFields = [];
    
    if (extractMapping) {
      Object.entries(extractMapping).forEach(([key, pathOrValue]) => {
        // Handle non-string values (like numbers) directly
        if (typeof pathOrValue !== 'string') {
          extractedValues[key] = pathOrValue;
          console.log(`Direct value for '${key}':`, pathOrValue);
          return;
        }
        
        // For string paths, try all possible locations
        let value = tryExtractFromMultipleLocations(data, pathOrValue);
        
        if (value !== undefined) {
          extractedValues[key] = value;
        } else {
          console.warn(`Could not find value for '${key}' using path '${pathOrValue}' in any location`);
          missingRequiredFields.push({ key, path: pathOrValue });
        }
      });
    }
    
    console.log("Extracted values:", extractedValues);
    
    // Check if any required fields are missing
    if (missingRequiredFields.length > 0) {
      console.error("Missing required fields:", missingRequiredFields);
      
      // Notify user about missing fields if notification function exists
      if (config.notificationFunction) {
        const missingFields = missingRequiredFields.map(f => f.key).join(', ');
        config.notificationFunction(
          `Failed to extract required fields: ${missingFields}. Please check your configuration.`, 
          'error'
        );
      }
      
      // Return early with error state if abortOnMissingFields is set
      if (config.abortOnMissingFields) {
        return {
          state: 'error',
          progress: `Missing required fields: ${missingRequiredFields.map(f => f.key).join(', ')}`,
          timestamp: new Date(),
          error: true
        };
      }
    }
    
    // Process messageTemplate based on type (object or string)
    let formattedMessage;
    
    if (messageTemplate) {
      console.log("if (messageTemplate)", messageTemplate);
      if (typeof messageTemplate === 'object') {
        console.log("if (typeof messageTemplate === 'object')", messageTemplate);
        // Handle object format with title and value
        formattedMessage = {
          title: messageTemplate.title,
          value: messageTemplate.value
        };
        console.log("messageTemplate - formattedMessage: ", formattedMessage);
        
        // Replace template variables in both title and value
        Object.entries(extractMapping || {}).forEach(([key, _]) => {
          const value = extractedValues[key];
          const replaceValue = value !== undefined ? value : 'thisWentWrong';
          
          if (formattedMessage.title) {
            formattedMessage.title = formattedMessage.title.replace(
              new RegExp(`{${key}}`, 'g'), 
              replaceValue
            );
          }
          
          if (formattedMessage.value) {
            formattedMessage.value = formattedMessage.value.replace(
              new RegExp(`{${key}}`, 'g'), 
              replaceValue
            );
          }
        });
      } else {
        console.log("else (typeof messageTemplate === 'object'): ", messageTemplate);
        // Handle legacy string format
        let message = messageTemplate;
        Object.entries(extractMapping || {}).forEach(([key, _]) => {
          const value = extractedValues[key];
          message = message.replace(
            new RegExp(`{${key}}`, 'g'), 
            value !== undefined ? value : 'undefined'
          );
        });
        formattedMessage = message;
      }
      console.log("Formatted message:", formattedMessage);
    }
    
    // Create job state entry - KEEPING EXTRACTED VALUES SEPARATE
    const jobState = {
      state: state || 'info',
      timestamp: new Date(),
      extractedData: extractedValues  // Keep extracted values in their own object
    };
    
    // Add message properties based on format
    if (formattedMessage) {
      if (typeof formattedMessage === 'object') {
        jobState.title = formattedMessage.title;
        jobState.value = formattedMessage.value;
        jobState.progress = formattedMessage.value; // For backward compatibility
      } else {
        jobState.progress = formattedMessage;
      }
    } else {
      jobState.progress = 'Updated'; // Default if no message provided
    }
    
    console.log("Final job state:", jobState);
    
    // Call the provided callback function
    if (config.appendFunction) {
      try {
        config.appendFunction(jobState);
      } catch (error) {
        console.error("Error in appendFunction:", error);
      }
    }
    
    return jobState;
  },
  
  // Shared parameter updates
  updateSharedParams: (data, config) => {
    const { extractMapping } = config;
    // console.log('== UPDATE SHARED PARAMS EXECUTION ==');
    // console.log('Extraction mapping:', extractMapping);
    // console.log('Input data:', data);
    
    // Extract values to store
    const paramsToUpdate = {};
    const extractedPaths = {}; // Track separately for template resolution
    let missingRequiredFields = [];
    
    if (extractMapping) {
      Object.entries(extractMapping).forEach(([paramKey, pathOrValue]) => {
        // Handle non-string values (like numbers) directly
        if (typeof pathOrValue !== 'string') {
          paramsToUpdate[paramKey] = pathOrValue;
          console.log(`Direct value for '${paramKey}':`, pathOrValue);
          return;
        }

        // Skip template strings in first pass (those containing curly braces)
        if (pathOrValue.includes('{')) {
          return;
        }
        
        // For string paths, try all possible locations
        let value = tryExtractFromMultipleLocations(data, pathOrValue);
        
        if (value !== undefined) {
          paramsToUpdate[paramKey] = value;
          // Also store with path as key for template resolution
          extractedPaths[pathOrValue] = value;
        } else {
          console.warn(`Could not find value for '${paramKey}' using path '${pathOrValue}' in any location`);
          missingRequiredFields.push({ key: paramKey, path: pathOrValue });
        }
      });
    }

    // Second pass: process template strings using extracted values
    Object.entries(extractMapping).forEach(([paramKey, pathOrValue]) => {
      // Only process string values that contain template markers
      if (typeof pathOrValue === 'string' && pathOrValue.includes('{')) {
        const resolvedValue = resolveTemplateString(pathOrValue, extractedPaths, data);
        paramsToUpdate[paramKey] = resolvedValue;
        console.log(`Resolved template for '${paramKey}':`, resolvedValue);
      }
    });
    
    console.log('Extracted parameters:', JSON.stringify(paramsToUpdate, null, 2));
    
    // Check if any required fields are missing
    if (missingRequiredFields.length > 0 && config.abortOnMissingFields) {
      console.error("Missing required fields:", missingRequiredFields);
      
      // Notify user about missing fields if notification function exists
      if (config.notificationFunction) {
        const missingFields = missingRequiredFields.map(f => f.key).join(', ');
        config.notificationFunction(
          `Failed to extract required fields: ${missingFields}. Please check your configuration.`, 
          'error'
        );
      }
      
      return {
        error: true,
        missingFields: missingRequiredFields.map(f => f.key)
      };
    }
    
    // Call update function if provided
    if (config.updateFunction && Object.keys(paramsToUpdate).length > 0) {
      try {
        config.updateFunction(paramsToUpdate);
      } catch (error) {
        console.error("Error in updateFunction:", error);
      }
    }
    
    return paramsToUpdate;
  },
  
  // Notification sender
  sendNotification: (data, config) => {
    const { message, type = 'info', extractPath } = config;
    // console.log('== SEND NOTIFICATION EXECUTION ==');
    // console.log('Config:', config);
    
    // Extract dynamic value if path provided
    let finalMessage = message;
    if (extractPath) {
      try {
        // Try multiple potential locations
        const extractedValue = tryExtractFromMultipleLocations(data, extractPath);
        
        finalMessage = finalMessage.replace('{value}', extractedValue !== undefined ? extractedValue : 'undefined');
        console.log(`Using extracted value for message:`, extractedValue);
      } catch (error) {
        console.error(`Error extracting value with path '${extractPath}':`, error);
        finalMessage = finalMessage.replace('{value}', 'undefined');
      }
    }
    
    console.log('Final message:', finalMessage);
    
    // Call the notification function if provided
    if (config.notificationFunction) {
      try {
        config.notificationFunction(finalMessage, type);
      } catch (error) {
        console.error("Error in notificationFunction:", error);
      }
    }
    
    return { message: finalMessage, type };
  }
};

/**
 * Helper function to try extracting a value from multiple possible locations
 */
const tryExtractFromMultipleLocations = (data, path) => {
  // Common locations to check, in order of priority
  const locationsToCheck = [
    { 
      obj: data.response?.data,
      pathAdjuster: (p) => stripDataPrefix(p)
    },
    { 
      obj: data.node?.response?.data,
      pathAdjuster: (p) => stripDataPrefix(p)
    },
    { 
      obj: data.response,
      pathAdjuster: (p) => p  // Use path as-is
    },
    { 
      obj: data,
      pathAdjuster: (p) => p  // Use path as-is
    }
  ];
  
  // Try each location and return the first match
  for (const location of locationsToCheck) {
    if (!location.obj) continue;  // Skip if this location doesn't exist
    
    const adjustedPath = location.pathAdjuster(path);
    console.log(`Trying path '${adjustedPath}' in location:`, location.obj);
    
    try {
      const value = getValueByPath(location.obj, adjustedPath);
      if (value !== undefined) {
        console.log(`Found value at adjusted path '${adjustedPath}':`, value);
        return value;
      }
    } catch (error) {
      console.error(`Error checking path '${adjustedPath}':`, error);
    }
  }
  
  return undefined;
};

/**
 * Removes 'data.' prefix from a path if it exists
 */
const stripDataPrefix = (path) => {
  if (path.startsWith('data.')) {
    return path.substring(5);  // Remove the 'data.' prefix
  }
  return path;
};

/**
 * Executes a dynamic callback based on configuration
 * 
 * @param {string} callbackType - Type of callback (afterResponse, onError, onComplete, etc)
 * @param {Object} data - Data from the API call
 * @param {Object} callbackConfig - Configuration for this specific callback
 * @param {Object} utilities - Helper functions like notification
 * @returns {*} Result of the callback execution
 */
export const executeCallback = (callbackType, data, callbackConfig, utilities = {}) => {
  console.log('== CALLBACK DATA STRUCTURE ==');
  console.log(JSON.stringify(data, null, 2).substring(0, 1000));
  console.log('== CALLBACK CONFIG STRUCTURE ==');
  console.log(JSON.stringify(callbackConfig, null, 2).substring(0, 1000));
  
  // If no config, do nothing
  if (!callbackConfig) {
    console.warn('[executeCallback] No callback config provided');
    return null;
  }
  
  // Check if we have the new multi-action format or legacy single-action format
  if (Array.isArray(callbackConfig.actions)) {
    console.log("== callbackConfig.actions: ", callbackConfig.actions);
    // Process multiple actions in sequence
    const results = [];
    
    for (const actionConfig of callbackConfig.actions) {
      // Skip if action is 'none'
      if (actionConfig.action === 'none') continue;
      

      // console.log('== executeCallback - actionConfig.action')
      // console.log('callbackType: ', callbackType)
      // console.log('data: ', data)
      // console.log('actionConfig: ', actionConfig)
      // console.log('utilities: ', utilities)
      // console.log(`= + = + = + =`)
      // console.log('Processing action: ', actionConfig.action)
      // console.log("====================");
      
      // Process this action
      try {
        const result = executeSingleAction(callbackType, data, actionConfig, utilities);

        // console.log("executeSingleAction(callbackType, data, actionConfig, utilities)");
        // console.log("result: ", result);
        if (result !== null) {
          results.push(result);
        }
      } catch (error) {
        // console.log('Error in action: ', actionConfig.action)
        // console.log('errorName:', error.name)
        // console.log('errorMessage:', errorMessage)
        // console.log('errorStack: ', error.stack)

        console.error(`Error executing action ${actionConfig.action} for ${callbackType}:`, error);
        
        // Show error notification if possible
        if (utilities.showNotification) {
          utilities.showNotification(`Error in ${callbackType} (${actionConfig.action}): ${error.message}`, 'error');
        }
      }
    }
    
    return results;
  } 
  // Legacy format with single action
  else if (callbackConfig.action) {
    // Skip if action is 'none'
    if (callbackConfig.action === 'none') {
      return null;
    }
    
    // Process the single action
    return executeSingleAction(callbackType, data, callbackConfig, utilities);
  }
  
  return null;
};

/**
 * Helper function to execute a single action
 */
const executeSingleAction = (callbackType, data, actionConfig, utilities) => {  
  // Add utilities to config if they exist
  // console.log('== ACTION HANDLER INPUT - executeSingleAction ==');
  // console.log('Data structure:', data);
  // console.log('Data structure:', JSON.stringify(data, null, 2).substring(0, 500));
  const { action, config = {} } = actionConfig;
  
  // console.log("callbackType: ", callbackType);
  // console.log("action", action);
  // console.log("config", config);
  // console.log("callbackRegistry[action]: ", callbackRegistry[action]);
  
  const enhancedConfig = {
    ...config,
    notificationFunction: utilities.showNotification
  };
  
  
  
  // return;
  // Check if we have a handler for this action
  if (callbackRegistry[action]) {
    try {
      // Execute the registered handler with the provided data and config
      const result = callbackRegistry[action](data, enhancedConfig);
      // console.log("== executeSingleAction - callbackRegistry[action]");
      // console.log("action", action);
      // console.log("enhancedConfig: ", enhancedConfig);
      // console.log('enhancedConfig being used:', JSON.stringify(enhancedConfig, null, 2).substring(0, 500));
      // console.log("callbackRegistry[action](data, enhancedConfig) - result", result);
      // console.log('== ^^^^  ===');

      return result;
    } catch (error) {
      
      // Show error notification if possible
      if (utilities.showNotification) {
        utilities.showNotification(`Error in ${callbackType}: ${error.message}`, 'error');
      }
      
      throw error; // Re-throw for the caller to handle
    }
  } else {
    console.warn(`No handler registered for action: ${action}`);
    return null;
  }
};

export default executeCallback;